import {unformatPostalCode} from 'commons/js/formatters/PostalCode';
import {ONE_DAY_IN_MILLISECONDS, THREE_MINUTES_IN_MILLISECONDS} from 'commons/js/utils/timeRanges'

export default async function (postalCode) {
  const treatedPostalCode = unformatPostalCode(postalCode);
  const key = `ME_postal_code:${treatedPostalCode}`;
  const isStorageDefined = typeof Storage !== "undefined";

  if (isStorageDefined) {
    const item = localStorage.getItem(key);

    if (item) {
      const value = JSON.parse(item);
      let ttl = ONE_DAY_IN_MILLISECONDS;

      if (!value.data) {
        ttl = THREE_MINUTES_IN_MILLISECONDS;
      }

      if (new Date() - value.timestamp <= ttl) {
        return value.data;
      }
    }
  }

  const {data} = await axios.get("/api/v2/postal-codes/" + treatedPostalCode);

  if (data) {
    isStorageDefined && localStorage.setItem(key, JSON.stringify({
      timestamp: new Date().getTime(),
      data: data[0]
    }));

    return data[0];
  }
}
